// extracted by mini-css-extract-plugin
export default {"color_nav":"nav_color_nav__qmkYo","list_align":"nav_list_align__F-Me5"};